export default __webpack_public_path__ + "static/media/logout.def71565.svg";